import React from 'react';
import PropertyGridUtils from '../PropertyGridUtils';


import "brace/theme/chrome";
import CodeEditor from './CodeEditor';

export default class JsEditor extends CodeEditor {
    mode = "html"
    render() {
        return super.render();
    }
}

PropertyGridUtils.register("html", (source, propertyGrid) => <JsEditor source={source} propertyGrid={propertyGrid} />);